<template lang="pug">
  .operator-requests
    .admin-page__title
      h1.title Отчеты
    .admin-page__filters
      .select-filter
        .form.form_wrap
          .form__elem
            custom-select(
            :list-data="types"
            :show-list="true"
            :read-only="false"
            :type="'type'"
            :default-value="filter.type"
            @on-change-default-value="changeSelectValue"
            )
          .form__elem
            custom-select(
            :list-data="areas"
            :show-list="true"
            :read-only="false"
            :type="'area'"
            :default-value="filter.area"
            @on-change-default-value="changeSelectValue"
            )
          .form__elem
            custom-select(
            :list-data="awards"
            :show-list="true"
            :read-only="false"
            :type="'award'"
            :default-value="filter.award"
            @on-change-default-value="changeSelectValue"
            )
          .form__elem
            .button.button_nowrap.button_paint-main(
            @click.prevent="onClickGetExcelOrders"
            :class="{'loaded-button':isPendingGetExcelOrders}"
            ) Экспортировать в Excel
    .admin-page__table
        requests-table(
        :orders="orders"
        :show-checkbox="false"
        )
    .admin-page__pagination(
      v-if="paginationAmountToShow < ordersAmount"
      )
        custom-pagination(
        :elements-amount="ordersAmount"
        :amount-to-show="paginationAmountToShow"
        :current-page="paginationCurrentPage"
        @on-button-click="onPaginationButtonClick"
        )
</template>

<script>
import { mapActions } from "vuex";
import RequestsTable from "../../../../components/requests-table/requests-table";
import CustomSelect from "../../../../components/custom-select/custom-select";
import StatusFilter from "../../../../components/status-filter/status-filter";
import TableActions from "../../../../components/table-actions/table-actions";
import Modal from "../../../../components/modal/modal";
import CustomPagination from "../../../../components/pagination/pagination";

export default {
  name: "admin-all-requests",
  components: {
    CustomPagination,
    Modal,
    TableActions,
    StatusFilter,
    CustomSelect,
    RequestsTable,
  },
  data() {
    return {
      awards: [],
      areas: [],
      events: [],
      orders: [],
      types: [
        {
          value: null,
          text: "Тип участника",
          paramName: "title",
        },
        {
          text: "Сопровождающий",
          value: true,
        },
        {
          text: "Участник",
          value: false,
        },
      ],
      params: {
        current_status__in: "3",
      },
      selected: [],
      orders_status_total: [],
      filter: {
        type: {
          value: null,
          text: "Тип участника",
          paramName: "title",
        },
        event: {
          value: null,
          text: "Мероприятия",
          paramName: "title",
        },
        area: {
          value: null,
          text: "Районы",
          paramName: "name",
        },
        award: {
          value: null,
          text: "Конкурсы",
          paramName: "title",
        },
        name: "",
      },
      timerId: null,
      isPendingGetExcelOrders: false,
      /*для пагинации*/
      ordersAmount: null,
      paginationAmountToShow: 25,
    };
  },
  computed: {
    paginationCurrentPage() {
      return Number(this.$route.query.page) || 1;
    },
  },
  methods: {
    ...mapActions([
      "getOrders",
      "getAwardTypes",
      "getAreas",
      "getEvents",
      "updateOrderStatus",
      "getExcelOrders",
    ]),
    onGetOrders(pageNumber) {
      this.params.page_size = this.paginationAmountToShow;
      this.params.page = pageNumber;
      this.getOrders(this.params).then((res) => {
        this.orders = res.results;
        this.orders_status_total = res.orders_status_total;
        this.ordersAmount = res.count;
      });
    },
    changeSelectValue(data, type) {
      this.filter[type] = data;
      this.params.event = this.filter.event.value;
      this.params.area__in = this.filter.area.value;
      this.params.award_type__in = this.filter.award.value;
      this.params.is_accompanying = this.filter.type.value;
      this.onPaginationButtonClick(1);
    },

    onPaginationButtonClick(button) {
      if (Number(this.$route.query.page) !== button) {
        this.$router.replace({ query: { page: button } });
      }
      this.onGetOrders(button);
    },

    onGetEvents() {
      this.getEvents().then((res) => {
        this.events.push(this.filter.event);
        let eventX = res.map((event) => ({
          text: event.title,
          value: event.id,
        }));
        this.events.push(...eventX);
      });
    },
    onGetAreas() {
      this.getAreas().then((res) => {
        this.areas.push(this.filter.area);
        let areaX = res.map((area) => ({
          text: area.name,
          value: area.id,
        }));
        this.areas.push(...areaX);
      });
    },
    onGetAward() {
      this.getAwardTypes().then((res) => {
        this.awards.push(this.filter.award);
        let awardX = res.map((award) => ({
          text: award.title,
          value: award.id,
        }));
        this.awards.push(...awardX);
      });
    },

    onClickGetExcelOrders() {
      this.isPendingGetExcelOrders = true;
      this.getExcelOrders(this.params).then((response) => {
        const url = response.url;
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Заявки.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        this.isPendingGetExcelOrders = false;
      });
    },
  },
  mounted() {
    this.onGetAward();
    this.onGetEvents();
    this.onGetAreas();
    this.onGetOrders(this.paginationCurrentPage);
  },
};
</script>
